module.exports = __webpack_public_path__ + "static/media/red-delete-icon.0f84306a.svg";